// extracted by mini-css-extract-plugin
export default {"child1":"styles_child1__Albj8","child2":"styles_child2__XN3E2","parent":"styles_parent__98vyu"};